import { BasePageTrackingService } from '../BasePageTrackingService';

export class WorksiteTrackingService extends BasePageTrackingService {
    protected getDefaultPage(): string {
        return this.getNestedPageWithTab();
    }
}
